import {
  createActions,
  createReqReducer,
  createReqWatcher,
  createReqConsts,
} from '../../utils/redux/index';

export const consts = createReqConsts('ui', 'reqSendReport');
export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: '',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['reportType'],
    },
    {
      type: 'payload',
      selector: ['reportableId'],
    },
    'complaints',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/complaints/reqSendReport.js